/* AMBRE product page behaviour (PDP area, pass 2). No dependencies. Hooks are data-pdp-* only, so nothing in am-theme.js binds twice.
   Cart: window.AM.cart.add([{id, quantity, properties}]) when the core layer provides it, otherwise POST /cart/add.js then /cart. */
(function () {
  if (window.__amPdpInit) return;
  window.__amPdpInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var AM = window.AM = window.AM || {};
  var root = AM.root || '/';

  function money(cents) {
    if (typeof AM.money === 'function') { try { return AM.money(cents); } catch (e) {} }
    var fmt = typeof AM.money === 'string' ? AM.money : (AM.moneyFormat || '$' + '{' + '{amount}' + '}');
    var n = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n).replace(/<[^>]+>/g, '');
  }

  function addToCart(items, toCheckout) {
    if (toCheckout) return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) { setTimeout(function () { window.location.href = root + 'checkout'; }, 300); return new Promise(function () {}); }); /* stays busy until the page leaves; the pause lets the add-to-cart pixel fire */
    if (AM.cart && typeof AM.cart.add === 'function') return Promise.resolve(AM.cart.add(items));
    return fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (j) { window.location.href = root + 'cart'; return j; });
  }

  /* ---------- sticky offset: the bar and the info column sit under the site header when it is stuck ---------- */
  function headerEl() { return $('.am-hd-sec') || $('.shopify-section-group-header-group') || $('header'); }
  function headerBottom() {
    var h = headerEl();
    if (!h) return 0;
    var cs = getComputedStyle(h);
    if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
    if (h.classList.contains('is-hidden')) return 0;
    return Math.round(((parseFloat(cs.top) || 0) + h.getBoundingClientRect().height) * 100) / 100;
  }

  function initProduct(box) {
    if (box.__pdp) return; box.__pdp = true;
    var dataEl = $('[data-pdp-json]', box), form = $('[data-pdp-form]', box);
    if (!dataEl || !form) return;
    var d; try { d = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = form.elements['id'], qtyInput = form.elements['quantity'];
    var state = [];
    var start = d.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || d.variants[0];
    start.options.forEach(function (o, i) { state[i] = o; });
    function find(st) { return d.variants.filter(function (v) { return v.options.every(function (o, i) { return st[i] === o; }); })[0]; }
    function qty() { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); }
    var list = $('[data-pdp-gal-list]', box), bar = $('[data-pdp-gal-bar]', box);

    function galItems() { return $$('[data-pdp-gal-item]', box); }
    function visibleItems() { return galItems().filter(function (s) { return !s.hidden; }).sort(function (a, b) { return (parseInt(a.style.order, 10) || 0) - (parseInt(b.style.order, 10) || 0); }); }
    function progress() {
      if (!list || !bar) return;
      var n = visibleItems().length || 1, max = list.scrollWidth - list.clientWidth;
      var p = max > 0 ? Math.min(1, Math.max(0, list.scrollLeft / max)) : 0;
      bar.style.width = ((1 / n + p * (1 - 1 / n)) * 100) + '%';
    }

    function renderGallery() {
      var color = d.ci >= 0 ? state[d.ci] : '';
      var items = galItems();
      var real = items.filter(function (s) { return s.hasAttribute('data-color'); });
      if (real.length) {
        /* a colour without photos yet keeps the set that is showing */
        var any = real.some(function (s) { return s.dataset.color === color; });
        if (any) real.forEach(function (s) { s.hidden = s.dataset.color !== '' && s.dataset.color !== color; });
      } else {
        items.forEach(function (s) {
          var cap = $('.am-ph__cap > span', s);
          if (cap && s.dataset.pdpPh != null) cap.textContent = (color ? color + ': ' : '') + s.dataset.pdpPh;
        });
      }
      /* the second set card (for example "Set with Bath Sheets") leads with the second gallery image, as on the reference */
      var swap = false;
      $$('[data-pdp-sets]', box).forEach(function (sets) {
        var cards = $$('[data-pdp-optel]', sets);
        if (cards.length === 2) { var i = parseInt(cards[1].dataset.i, 10); if (state[i] === cards[1].dataset.value) swap = true; }
      });
      var vis = items.filter(function (s) { return !s.hidden; });
      items.forEach(function (s) { s.style.order = ''; s.classList.remove('is-first'); });
      if (swap && vis.length > 1) { vis[0].style.order = '1'; vis[1].style.order = '0'; vis.slice(2).forEach(function (s) { s.style.order = '2'; }); }
      var first = swap && vis.length > 1 ? vis[1] : vis[0];
      if (first) first.classList.add('is-first');
      if (list) list.scrollLeft = 0;
      progress();
      /* thumbs in the selected bar and the sticky bar follow the colour when real photos exist */
      var img = first && $('img', first);
      if (img) $$('[data-pdp-bar-img] img,[data-pdp-sticky-img] img', box).forEach(function (t) { t.removeAttribute('srcset'); t.src = img.currentSrc || img.src; });
    }

    function render(first) {
      var v = find(state); if (!v) return;
      idInput.value = v.id;
      var q = qty();
      $$('[data-pdp-price]', box).forEach(function (e) { e.textContent = money(v.price); e.classList.toggle('is-sale', v.compare_at_price > v.price); });
      $$('[data-pdp-compare]', box).forEach(function (e) { e.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
      $$('[data-pdp-btn-price]', box).forEach(function (e) { e.textContent = money(v.price * q); });
      $$('[data-pdp-atc],[data-pdp-sticky-atc]', box).forEach(function (b) { b.disabled = v.available === false; });
      /* sold out: the button says so, and a colour with nothing left is struck through in the swatch rows */
      var out = v.available === false;
      $$('[data-pdp-atc-label],[data-pdp-sticky-atc]', box).forEach(function (e) {
        if (e.dataset.amLabel == null) e.dataset.amLabel = e.textContent;
        e.textContent = out ? 'Sold out' : e.dataset.amLabel;
      });
      $$('.am-pdp-atc__p', box).forEach(function (e) { e.hidden = out; });
      if (d.ci >= 0 && !box.__amOut) {
        box.__amOut = true;
        var gone = {};
        d.variants.forEach(function (x) { var c = x.options[d.ci]; if (gone[c] == null) gone[c] = true; if (x.available !== false) gone[c] = false; });
        $$('[data-pdp-pick]', box).forEach(function (inp) { if (parseInt(inp.dataset.i, 10) === d.ci && gone[inp.value]) { var it = inp.closest('.am-pdp-sw__item'); if (it) { it.classList.add('is-out'); var l = it.querySelector('label'); if (l) l.title = inp.value + ' (sold out)'; } } });
        $$('[data-pdp-color-select] option', box).forEach(function (o) { if (gone[o.value] && !/sold out/.test(o.textContent)) o.textContent = o.textContent + ' (sold out)'; });
      }
      if (d.ci >= 0) {
        var color = state[d.ci];
        $$('[data-pdp-color-name]', box).forEach(function (e) { e.textContent = color; });
        $$('[data-pdp-color-dot]', box).forEach(function (e) { e.style.setProperty('--sw', (d.swatches && d.swatches[color]) || '#ccc'); });
        $$('[data-pdp-color-select]', box).forEach(function (s) { s.value = color; });
      }
      $$('[data-pdp-opt-name]', box).forEach(function (e) { e.textContent = state[parseInt(e.dataset.pdpOptName, 10)]; });
      $$('[data-pdp-pick]', box).forEach(function (inp) { inp.checked = state[parseInt(inp.dataset.i, 10)] === inp.value; });
      $$('[data-pdp-optel]', box).forEach(function (el) {
        var i = parseInt(el.dataset.i, 10), val = el.dataset.value, st = state.slice(); st[i] = val;
        el.classList.toggle('is-on', state[i] === val);
        var vv = find(st); if (!vv) return;
        var p = $('[data-pdp-o-price]', el), c = $('[data-pdp-o-compare]', el), s = $('[data-pdp-o-save]', el), sw = $('[data-pdp-o-savewrap]', el), pp = $('[data-pdp-o-each]', el);
        var pieces = parseInt(el.dataset.pieces, 10) || 0;
        if (p) p.textContent = money(vv.price);
        if (c) c.textContent = vv.compare_at_price > vv.price ? money(vv.compare_at_price) : '';
        if (s) s.textContent = money(Math.max(0, vv.compare_at_price - vv.price));
        if (sw) sw.hidden = !(vv.compare_at_price > vv.price);
        if (pp && pieces) pp.textContent = money(Math.floor(vv.price / pieces));
      });
      if (!first) {
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
      }
      box.dispatchEvent(new CustomEvent('pdp:variant', { bubbles: true, detail: { variant: v, quantity: q } }));
    }

    box.addEventListener('change', function (e) {
      var t = e.target;
      if (t.matches('[data-pdp-pick]')) {
        var i = parseInt(t.dataset.i, 10); state[i] = t.value; render();
        if (i === d.ci || t.closest('[data-pdp-sets]')) renderGallery();
      } else if (t.matches('[data-pdp-color-select]')) {
        state[d.ci] = t.value; render(); renderGallery();
      } else if (t === qtyInput) { syncQty(); render(); }
    });

    /* quantity stepper */
    function syncQty() {
      if (!qtyInput || qtyInput.type === 'hidden') return;
      var q = qty(); qtyInput.value = q;
      qtyInput.style.width = Math.max(16, String(q).length * 9) + 'px';
      var minus = $('[data-pdp-qty="-1"]', box); if (minus) minus.disabled = q <= 1;
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pdp-qty]');
      if (b && qtyInput) { e.preventDefault(); qtyInput.value = Math.max(1, qty() + parseInt(b.dataset.pdpQty, 10)); syncQty(); render(); }
    });

    /* add to cart */
    function submit() {
      var btns = $$('[data-pdp-atc],[data-pdp-sticky-atc]', box), err = $('[data-pdp-err]', box);
      var items = [{ id: parseInt(idInput.value, 10), quantity: qty() }];
      var gift = $('[data-pdp-gift]', box);
      if (gift && gift.checked) items.push({ id: parseInt(gift.value, 10), quantity: 1 });
      window.AMPDP = window.AMPDP || {}; window.AMPDP.lastPayload = { items: items, via: AM.cart && typeof AM.cart.add === 'function' ? 'AM.cart.add' : '/cart/add.js' };
      btns.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      if (err) err.hidden = true;
      var done = function () { btns.forEach(function (b) { b.disabled = false; b.removeAttribute('aria-busy'); }); };
      var p; try { p = addToCart(items, form.hasAttribute('data-pdp-checkout')); } catch (ex) { p = Promise.reject(ex); }
      return p.then(done, function (ex) { if (err) { err.textContent = (ex && ex.message) || 'Could not add to cart'; err.hidden = false; } done(); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); e.stopImmediatePropagation(); submit(); }, true);
    var sb = $('[data-pdp-sticky-atc]', box);
    if (sb) sb.addEventListener('click', function (e) { e.preventDefault(); submit(); });

    /* promo code bar: copy the code */
    $$('[data-pdp-promo]', box).forEach(function (bar) {
      var sub = $('[data-pdp-promo-sub]', bar), btn = $('[data-pdp-promo-btn]', bar), keep = sub ? sub.textContent : '', timer;
      if (!btn) return;
      btn.addEventListener('click', function () {
        var code = bar.dataset.code, done = function () { bar.classList.add('is-copied'); if (sub) sub.textContent = 'Copied, paste it at checkout'; clearTimeout(timer); timer = setTimeout(function () { bar.classList.remove('is-copied'); if (sub) sub.textContent = keep; }, 2500); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done);
        else { var ta = document.createElement('textarea'); ta.value = code; ta.style.position = 'absolute'; ta.style.left = '-9999px'; document.body.appendChild(ta); ta.select(); try { document.execCommand('copy'); } catch (e) {} document.body.removeChild(ta); done(); }
      });
    });

    /* size guide popup */
    var guide = $('[data-pdp-guide]', box);
    if (guide) {
      var gOpen = function (on) { guide.hidden = !on; document.documentElement.style.overflow = on ? 'hidden' : ''; };
      $$('[data-pdp-guide-open]', box).forEach(function (b) { b.addEventListener('click', function () { gOpen(true); }); });
      guide.addEventListener('click', function (e) {
        if (e.target === guide || e.target.closest('[data-pdp-guide-close]')) { gOpen(false); return; }
        var t = e.target.closest('[data-pdp-guide-tab]');
        if (t) {
          $$('[data-pdp-guide-tab]', guide).forEach(function (x) { x.classList.toggle('is-on', x === t); });
          $$('[data-pdp-guide-panel]', guide).forEach(function (x) { x.classList.toggle('is-on', x.dataset.pdpGuidePanel === t.dataset.pdpGuideTab); });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !guide.hidden) gOpen(false); });
    }

    /* tabs */
    $$('[data-pdp-tabs]', box).forEach(function (tabs) {
      var btns = $$('[data-pdp-tab]', tabs), panels = $$('[data-pdp-panel]', tabs), line = $('[data-pdp-tab-line]', tabs);
      function go(b) {
        btns.forEach(function (x) { x.setAttribute('aria-selected', x === b ? 'true' : 'false'); });
        panels.forEach(function (p) { p.hidden = p.dataset.pdpPanel !== b.dataset.pdpTab; });
        if (line) { line.style.width = b.offsetWidth + 'px'; line.style.left = b.offsetLeft - b.parentNode.offsetLeft + 'px'; }
      }
      btns.forEach(function (b) { b.addEventListener('click', function () { go(b); }); });
      var cur = btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || btns[0];
      if (cur) { go(cur); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { go(btns.filter(function (b) { return b.getAttribute('aria-selected') === 'true'; })[0] || cur); }); }
    });

    /* gallery progress */
    if (list) { list.addEventListener('scroll', progress, { passive: true }); window.addEventListener('resize', progress); }

    /* sticky bar */
    var sticky = $('[data-pdp-sticky]', box), buy = $('[data-pdp-buy]', box);
    function onScroll() {
      var top = headerBottom();
      box.style.setProperty('--pdp-top', top + 'px');
      if (!sticky || !buy) return;
      var r = buy.getBoundingClientRect();
      var footer = $('.shopify-section-group-footer-group') || $('footer');
      var fr = footer ? footer.getBoundingClientRect() : null;
      var on = r.bottom < Math.max(top, 1) && !(fr && fr.top < window.innerHeight);
      if (on !== sticky.classList.contains('is-on')) {
        sticky.classList.toggle('is-on', on);
        sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (sb) sb.tabIndex = on ? 0 : -1;
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    var hd = headerEl();
    if (hd && 'MutationObserver' in window) new MutationObserver(onScroll).observe(hd, { attributes: true, attributeFilter: ['class'] });

    /* complementary products: filled by Shopify when the Search & Discovery app has pairs for this product */
    var reco = $('[data-pdp-reco]', box);
    if (reco && reco.dataset.url && !reco.children.length) {
      fetch(reco.dataset.url, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pdp-reco-inner]');
        if (inner) reco.appendChild(inner);
      }).catch(function () {});
    }

    syncQty(); render(true); renderGallery(); onScroll();
  }

  /* ---------- testimonial slider (below the fold) ---------- */
  function initSlider(box) {
    if (box.__pdx) return; box.__pdx = true;
    var sc = $('[data-pdx-scroller]', box);
    $$('[data-pdx-nav]', box).forEach(function (b) { b.addEventListener('click', function () {
      if (!sc) return; var card = sc.firstElementChild; var w = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(sc).columnGap || 0) : sc.clientWidth;
      sc.scrollBy({ left: (b.dataset.pdxNav === 'prev' ? -1 : 1) * w, behavior: 'smooth' });
    }); });
    $$('[data-pdx-play]', box).forEach(function (b) { b.addEventListener('click', function () {
      var v = $('video', b.parentNode); if (!v) return;
      if (v.paused) { $$('video', box).forEach(function (o) { if (o !== v) { o.pause(); var ob = $('[data-pdx-play]', o.parentNode); if (ob) ob.hidden = false; } }); v.muted = false; v.play(); b.hidden = true; } else { v.pause(); }
    }); });
    $$('video', box).forEach(function (v) { v.addEventListener('click', function () { v.pause(); var b = $('[data-pdx-play]', v.parentNode); if (b) b.hidden = false; }); });
  }

  function boot() { $$('[data-pdp]').forEach(initProduct); $$('[data-pdx-slider]').forEach(initSlider); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
